import { DomainContext, Server } from '@sai/protocol';
import ImageUtils from './ImageUtils';
import ConfigUtils from './ConfigUtils';
import I18NUtils from './I18NUtils';

class ServerUtils {
    private static _instance: ServerUtils;
    private isServerInitialized: boolean = false;

    static get Instance() {
        return this._instance || (this._instance = new this());
    }

    public sendFile(srcId, file, url, onProgress): Promise<any> {
        var formData = new FormData();
        formData.append('device', 'web');
        return new Promise((accept, reject) => {
            ImageUtils.resizeImage(file, 2048000)
                .then((fileResult) => {
                    formData.append('file', fileResult, fileResult.name);
                    $.ajax({
                        url: url,
                        type: 'POST',
                        xhr: function () {  // Custom XMLHttpRequest
                            var myXhr = $.ajaxSettings.xhr();
                            if (myXhr.upload) { // Check if upload property exists
                                myXhr.upload.addEventListener('progress', onProgress.bind(srcId), false); // For handling the progress of the upload
                            }
                            return myXhr;
                        },
                        statusCode: {
                            500: reject,
                            502: reject,
                            401: reject
                        },
                        //Ajax events
                        success: accept,
        
                        // Form data
                        data: formData,
                        //Options to tell jQuery not to process data or worry about content-type.
                        cache: false,
                        contentType: false,
                        processData: false,
                        dataType: 'json'
                    });
                })
                .catch(reject);

        });
    }

    public getDomainContext(domain: string) {
        return new DomainContext(domain, $('html').data('timestamp'));
    }

    private readFile(file): Promise<string|ArrayBuffer> {
        return new Promise((accept, reject) => {
            const filereader = new FileReader();
            filereader.onload = function() {
                accept(filereader.result);
            }
            filereader.readAsDataURL(file);
        });
    }

    public initializeServer() {
        Server.initialize({
            serverUrl: location.origin + ConfigUtils.getRelativePath(),
            deviceType: 'web',
            callbacks: {
                sessionTimeoutCallback: undefined,
                globalFailureCallback: (error: any) => { },
                missingAuthCallback: (message: any, resolve: any, reject: any) => {
                    reject('There shouldn\'t be any require authentication');
                },
                ongoingMessageCallback: undefined,
                displayMessageCallback: undefined,
                i18NEntryCallback: (code: string) => I18NUtils.getMessage(code, 'fr', {})
            },
            timeout: 0
        });
        this.isServerInitialized = true;
    }

    public getServer(): typeof Server {
        if(!this.isServerInitialized) {
            this.initializeServer();
        }
        return Server;
    }
}

const singleInstance = ServerUtils.Instance;
export default singleInstance;